import dynamic from "next/dynamic";

export const DynamicContent084 = dynamic(() => import("./Content084"), {
  suspense: true,
});
